const styles = () => ({
    container: {
        height: 'auto',
        padding: '1em 2em 2em 2em',
    },
    tabsContainer: {
        marginTop: '10px',
        marginBottom: '10px',
        borderBottom: '1px solid #ccc',
    },
    tabs: {
        flex: 1,
        textTransform: 'none',
    },
    tab: { maxWidth: '25%' },
    containerForm: {
        position: 'relative',
        paddingBottom: '130px',
    },
    actionsContainer: {
        flex: 1,
        padding: '30px',
        margin: '50px 12px 0 12px',
        display: 'flex',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    actionsBtns: {
        borderRadius: '20px',
        width: '190px',
        height: '40px',
    },
    colorWhite: {
        color: '#fff',
    },
    loading: {
        margin: '0',
    },
    iconDocument: {
        borderRadius: '50%',
        background: '#e9e9e9',
        padding: '5px',
    },
    icon: {
        fontSize: '17px',
    },
});

export default styles;
